import Vue from 'vue';

/**
 * 此marco提供一个固定的UI,对指定文本以主色渲染,同时提供点击事件(事件名columnClick,参数类型为elBodyScope)和复制功能
 * 相关的类声明全局声明在父组件中
 * 注意columnClick事件需要在tableDefiner处实现,否则无效果
 */

export function macroCopyAndJump(vm: Vue, h: any) {
    vm.$set(vm.$data.scope, 'select', null);

    const scopedSlots = {
        default: function (body) {
            const desc = body.desc;
            const copyProc = () => {
                navigator.clipboard.writeText(body.row[desc.prop]);
                vm.$message.success("复制成功");
            }

            return <div class="macroCopyAndJump">
                <span class="pointer color-main" {...{ on: { click: () => vm.$emit('columnClick', body) } }}>{body.row[desc.prop]}</span>
                <svg {...{ on: { click: copyProc } }} class="cpy fill-main" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2548" width="16" height="16">
                    <path d="M672 832H224c-52.928 0-96-43.072-96-96V160c0-52.928 43.072-96 96-96h448c52.928 0 96 43.072 96 96v576c0 52.928-43.072 96-96 96zM224 128c-17.632 0-32 14.368-32 32v576c0 17.664 14.368 32 32 32h448c17.664 0 32-14.336 32-32V160c0-17.632-14.336-32-32-32H224z" p-id="2549">
                    </path>
                    <path d="M800 960H320c-17.664 0-32-14.304-32-32s14.336-32 32-32h480c17.664 0 32-14.336 32-32V256c0-17.664 14.304-32 32-32s32 14.336 32 32v608c0 52.928-43.072 96-96 96zM544 320H288c-17.664 0-32-14.336-32-32s14.336-32 32-32h256c17.696 0 32 14.336 32 32s-14.304 32-32 32zM608 480H288.032c-17.664 0-32-14.336-32-32s14.336-32 32-32H608c17.696 0 32 14.336 32 32s-14.304 32-32 32z" p-id="2550">   
                    </path>
                    <path d="M608 640H288c-17.664 0-32-14.304-32-32s14.336-32 32-32h320c17.696 0 32 14.304 32 32s-14.304 32-32 32z" p-id="2551">
                    </path>
                </svg>
            </div>
        },
    }

    return <colDefiner {...{ scopedSlots }}></colDefiner>;
}